import React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";
import FormHelperText from "@material-ui/core/FormHelperText";

export const enumRenderer = (
    value,
    name,
    values,
    defaultVal,
    fieldUpdateHandler,
    mutable,
    isError,
) => {
    const options = Array.isArray(values)
        ? values.map((value, index) => (
              <MenuItem key={index} value={value}>
                  {value}
              </MenuItem>
          ))
        : Object.entries(values).map((entry) => (
              <MenuItem key={entry[0]} value={entry[0]}>
                  {entry[1]}
              </MenuItem>
          ));
    return mutable ? (
        <>
            <Select
                value={value}
                defaultValue={defaultVal}
                onChange={(e) => fieldUpdateHandler(name, e.target.value)}
            >
                {options}
            </Select>
            {!!isError && (
                <FormHelperText style={{ color: "red" }}>
                    {isError}
                </FormHelperText>
            )}
        </>
    ) : (
        <Typography>{values[value]}</Typography>
    );
};
